module.exports = __webpack_public_path__ + "static/media/report_epargn.f9c6a13f.svg";